import axios from 'axios'
import store from '@/store'
import { APP_BASE } from '@/config/appBase'

axios.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers.Authorization = `Bearer ${store.getters.token}`
  }
  return config
},
error => Promise.reject(error)
)

axios.interceptors.response.use(resp => {
  if (resp.headers.access_token) {
    store.commit('setToken', resp.headers.access_token)
  }
  return resp
}, function (error) {
  if (error.response && error.response.status === 401) {
    store.commit('deleteToken')
    window.location = APP_BASE + '/noaccess'
  }
  return Promise.reject(error)
})
